import { useQuery } from 'react-query'
import { useAtomValue } from 'jotai'
import { strideAccountAtom } from '@/atoms/Wallet'
import { queryKeys } from '@/query-keys'
import { stride } from 'stridejs'
import { STRIDE_CHAIN_INFO, AIRDROP_IDENTIFIERS } from '@/config'
import { fatal } from '@/utils'

interface ActionStatus {
  claim: boolean
  liquidStake: boolean
  stake: boolean
}

const useTaskStatusQuery = () => {
  const strideAccount = useAtomValue(strideAccountAtom)

  const handleRequest = async (): Promise<ActionStatus> => {
    if (!strideAccount) {
      throw fatal('Unable to fetch claim records while wallet is disconnected.')
    }

    const client = await stride.ClientFactory.createRPCQueryClient({
      rpcEndpoint: STRIDE_CHAIN_INFO.rpc
    })

    const data = await Promise.all(
      AIRDROP_IDENTIFIERS.map((identifier) => {
        return client.stride.claim.claimRecord({
          address: strideAccount.key.bech32Address,
          airdropIdentifier: identifier
        })
      })
    )

    const records = data
      .map((item) => {
        return item.claimRecord
      })
      .filter(Boolean)

    return {
      claim: records.map((record) => record.actionCompleted[0]).some(Boolean),
      liquidStake: records.map((record) => record.actionCompleted[1]).some(Boolean),
      stake: records.map((record) => record.actionCompleted[2]).some(Boolean)
    }
  }

  return useQuery(
    queryKeys.airdropClaimRecordByAddress({ address: strideAccount?.key.bech32Address ?? '' }),
    handleRequest,
    { enabled: Boolean(strideAccount) }
  )
}

export { useTaskStatusQuery }
